import React from 'react';
import {GetRequestResponsePayload} from '../../../../../../shared/models/api';
import {NamedStyles} from '../../../../../../shared/hooks/styles';
import {View} from 'react-native';
import {Link} from '../../../../../../shared/components/link';
import {getApiRoute} from '../../../../../../shared/pipes';
import {apiUrls} from '../../../../../../shared/constants/urls';
import {images} from '../../../../../../assets/icons';
import {Text} from '../../../../../../shared/components/text';
import {useIsDesktop} from '../../../../../../shared/hooks/useIsDesktop';

export const Links = ({
  type,
  request,
  styles,
}: {
  type: 'appeal' | 'response';
  request: GetRequestResponsePayload | null;
  styles: NamedStyles<any>;
}) => {
  const isResponse = type === 'response';
  const links = isResponse ? request?.responseFiles : request?.appealFiles;
  const isDesktop = useIsDesktop();
  const iconSize = isDesktop ? 24 : 16;

  return (
    <View style={styles.linkContainer}>
      {links?.map((file) => {
        return (
          <Link
            testID={`topic-form-content-file-${file.id}-link-id`}
            style={styles.linkSubContainer}
            key={file.id}
            download
            fileName={file.name}
            href={getApiRoute(apiUrls[isResponse ? 'getResponseFile' : 'getAppealFile'], {id: file.id || ''})}>
            <images.Clip height={iconSize} width={iconSize} color={(styles.linkContainer as any).color} />
            <Text style={styles.link}>{file.name}</Text>
          </Link>
        );
      })}
    </View>
  );
};
